export const environment = {
  production: true,
  isMyParkingDeployment: false,
  apiBaseUrl: 'https://asia-southeast1-parkbot-ph-prd.cloudfunctions.net'
};

export const firebaseConfig = {

  // apiKey: "AIzaSyDOsJu1tOGTRvs9tOPeSQpcC05PpF679I0",
  // authDomain: "parkbotph-staging.firebaseapp.com",
  // projectId: "parkbotph-staging",
  // storageBucket: "parkbotph-staging.appspot.com",
  // messagingSenderId: "462181268030",
  // appId: "1:462181268030:web:5c37951655186046b8af6f",
  // measurementId: "G-BDQLZJSLQ9"

  apiKey: "AIzaSyDH1lKVYFSGgQCamc9-00XIn3b2Lci-QyY",
  authDomain: "parkbot-ph-prd.firebaseapp.com",
  projectId: "parkbot-ph-prd",
  storageBucket: "parkbot-ph-prd.appspot.com",
  messagingSenderId: "787780322172",
  appId: "1:787780322172:web:426cb63a2eff9afd9cdaf9",
  measurementId: "G-J2GV5FQX23"
}

export const mayaConfig = {
  sandbox: {
    publicKey: 'pk-Z0OSzLvIcOI2UIvDhdTGVVfRSSeiGStnceqwUE7n0Ah',
    secretKey: 'sk-X8qolYjy62kIzEbr0QRK1h4b4KDVHaNcwMYk39jInSl',
    baseUrl: 'https://pg-sandbox.paymaya.com'
  },
  production: {
    publicKey: 'pk-soBBKR9rlagDoT7hkMYfO21cGkLRU90ThWcQIj1q14s',
    secretKey: 'sk-HQjEBOY1BHiiRPEmLpY0ocUVP0lNCKCnQnlkdCegOMA',
    baseUrl: 'https://pg.paymaya.com'
  }
}
